import { YesOrNo } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Boolean";
import { DeductibleValue } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Deductible";
import { ProductOwner } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/ProductOwner";
import { ProductDetail } from "Components/InsuranceDetailsCard/ProductDetailsTable/interface";
import { VeteranAutoProduct } from "Store/interfaces/products/checkout/riskProducts/vehicleProducts/VeteranAutoProduct";
import React from "react";

export const veteranAutoDetailsList = (
  product: VeteranAutoProduct,
  urls: Record<string, string>,
): ProductDetail[] => {
  const { applicableTermsVeteranAuto } = urls;

  return [
    {
      name: "deductible",
      value: (
        <a href={applicableTermsVeteranAuto} target="_blank" rel="noreferrer">
          {<DeductibleValue value={"??"} />}
        </a>
      ),
    },
    {
      name: "brand",
      value: product.brand,
    },
    {
      name: "modelAndValue",
      value: product.model,
    },
    {
      name: "firstRegistered",
      value: product.modelYear,
    },
    {
      name: "isMemberOfVeteranClub",
      value: <YesOrNo value={product.isMemberOfVeteranClub} />,
    },
    {
      name: "insuranceHolderIsOwner",
      value: (
        <ProductOwner
          isOwner={product.insuranceHolderIsOwner}
          owner={product.owner}
        />
      ),
    },
    { name: "damageRecentYears", value: product.damageCountRecentYears ?? 0 },
    {
      name: "yearOfLastDamage",
      value: product.yearOfLastDamage,
      hidden: product.damageCountRecentYears === 0,
    },
  ];
};
